"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeUserPassword = exports.sendPasswordResetCode = exports.submitPhoneEnrollmentMfaCode = exports.createUserPassword = exports.enrollUser2fa = exports.userResetMfa = exports.activateUser = exports.editUserInfo = exports.createUser = exports.attemptKycAuth = exports.attemptKyc = exports.setUserSetting = exports.getUserSettings = exports.getUserInfo = void 0;
const api_client_1 = require("@App/api/api-client");
const pathes_1 = __importDefault(require("@App/dicts/pathes"));
const getUserInfo = () => api_client_1.axiosClient.get(pathes_1.default.User.userInfo);
exports.getUserInfo = getUserInfo;
const getUserSettings = () => api_client_1.axiosClient.get(pathes_1.default.User.userGetSettings);
exports.getUserSettings = getUserSettings;
const setUserSetting = (setting) => api_client_1.axiosClient.put(pathes_1.default.User.userSetSetting, setting);
exports.setUserSetting = setUserSetting;
const attemptKyc = (userExposedId) => api_client_1.axiosClient.patch(pathes_1.default.User.attemptKyc(userExposedId), {});
exports.attemptKyc = attemptKyc;
const attemptKycAuth = (userExposedId) => api_client_1.axiosClient.patch(pathes_1.default.User.attemptKycAuth(userExposedId), {});
exports.attemptKycAuth = attemptKycAuth;
const createUser = (user) => api_client_1.axiosClient.post(pathes_1.default.User.createUser, user);
exports.createUser = createUser;
const editUserInfo = (user) => api_client_1.axiosClient.put(pathes_1.default.User.userInfo, user);
exports.editUserInfo = editUserInfo;
const activateUser = (activationCode) => api_client_1.axiosClient.get(pathes_1.default.User.activateUser(activationCode));
exports.activateUser = activateUser;
const userResetMfa = (userId) => api_client_1.axiosClient.post(pathes_1.default.User.resetMfa(userId));
exports.userResetMfa = userResetMfa;
const enrollUser2fa = (useSms, email, password, phoneCountryCode, phoneAreaCode, phoneNumber) => api_client_1.axiosClient.post(pathes_1.default.User.userEnable2fa, {
    useSms: useSms,
    email: email,
    password: password,
    phoneCountryCode: phoneCountryCode,
    phoneAreaCode: phoneAreaCode,
    phoneNumber: phoneNumber,
});
exports.enrollUser2fa = enrollUser2fa;
const createUserPassword = (activationCode, newPassword, phoneCountryCode, phoneAreaCode, phoneNumber) => {
    const request = {
        newPassword,
        phoneCountryCode,
        phoneAreaCode,
        phoneNumber,
    };
    return api_client_1.axiosClient.post(pathes_1.default.User.activateUser(activationCode), request);
};
exports.createUserPassword = createUserPassword;
const submitPhoneEnrollmentMfaCode = (code, mfaToken) => api_client_1.axiosClient.post(pathes_1.default.Auth.mfaSubmit, { code, mfaToken });
exports.submitPhoneEnrollmentMfaCode = submitPhoneEnrollmentMfaCode;
const sendPasswordResetCode = () => api_client_1.axiosClient.post(pathes_1.default.User.sendResetPasswordCode);
exports.sendPasswordResetCode = sendPasswordResetCode;
const changeUserPassword = (accessToken, previousPassword, proposedPassword) => api_client_1.axiosClient.post(pathes_1.default.User.userPassChange, {
    accessToken,
    previousPassword,
    proposedPassword,
});
exports.changeUserPassword = changeUserPassword;
